import styled from 'styled-components'

import { theme } from 'styles/theme'

const { colors, media, radii, space } = theme

/* O BestChoice é compartilhado entre várias páginas, então o CTA dele vem com a
   geometria do módulo: largura pelo conteúdo e sem altura fixa. Aqui ele é
   alinhado aos demais CTAs desta página sem mexer no módulo. O seletor inclui a
   section porque a regra de origem tem a mesma especificidade. */
export const BestChoiceWrapper = styled.div`
  /* O Layout centraliza os filhos (align-items: center): sem largura própria,
     o wrapper encolhe até o max-width do Grid e o fundo da section não chega
     às bordas em telas largas. */
  width: 100%;

  & > section .ds-button {
    width: 100%;
    height: ${space['spacing-mega']};
    padding: 0 ${space['spacing-sm']};
    border-radius: ${radii['corner-radius-pill']};

    &:focus-visible {
      outline: 2px solid ${colors['neutral-border-default']};
      outline-offset: 3px;
    }
  }

  @media (${media.desktop}) {
    & > section .ds-button {
      width: 230px;
    }
  }
`
